export default {
  methods: {

    checkStocks () {
      const warehouseCode = this.user.location_code

      if (!warehouseCode) {
        return this.swalInvalid('<h6>Please select a location first</h6>')
      }

      const productCodes = this.$refs.componentProducts.getFinalProducts().map(
        detail => detail.product_code
      ).filter(code => code)

      if (productCodes.length === 0) {
        return this.swalInvalid('<h6>Please select a product first</h6>')
      }

      this.getStocks(this, warehouseCode, productCodes).finally(() => {
        this.$refs.componentProducts.setStocksOfProducts(this.options.stocks)
      })

      this.$root.$emit('bv::hide::tooltip')
    },

    createRequest () {
      this.editing = false

      this.editAsDraft = true

      this.stockRequest = Object.assign(this.stockRequest, {
        id: '',
        stage: 0,
        references: {
          document_number: '',
          transfer_number: '',
          sap_doc_entry: '',
          transaction_number: ''
        },
        headers: {
          withdrawal: '',
          withdrawal_transaction_number: '',
          destination: '',
          destination_name: '',
          destination_code: ''
        },
        delivery_details: {
          date: '',
          vehicle: '',
          vehicle_plate: '',
          vehicle_name: '',
          driver: '',
          driver_name: '',
          mobile_number: '',
          is_3pl: 0,
          helper: ''
        },
        approvals: [],
        created_at: '',
        details: Array.from({ length: 5 }).map(
          () => ({
            product: null,
            quantity: null,
            onhand_quantity: 0
          })
        ),
        remarks: ''
      })

      this.getDestinations(this).finally(() => {
        this.getProducts(this)
        this.getDrivers(this)
        this.getVehicles(this)
      })

      this.$bvModal.show('modalRequest')
    },

    submitRequest (remarks = '') {
      const { id, headers, delivery_details } = this.stockRequest
      return this.$refs.srPending.create({
        id: id,
        destination: headers.destination,
        withdrawal: headers.withdrawal,
        withdrawal_transaction_number: headers.withdrawal_transaction_number,
        remarks: remarks,
        delivery_details: {
          date: delivery_details.date,
          vehicle: delivery_details.vehicle,
          vehicle_plate: delivery_details.vehicle_plate,
          vehicle_name: delivery_details.vehicle_name,
          driver: delivery_details.driver,
          driver_name: delivery_details.driver_name,
          mobile_number: delivery_details.mobile_number,
          is_3pl: delivery_details.is_3pl,
          helper: delivery_details.helper
        },
        details: this.$refs.componentProducts.getFinalProducts(),
        active: 1
      }).then(() => {
        this.currentTabIndex = 0
      }).catch(
        errors => {
          if (errors.errors) {
            if (this.$refs.formStockRequest) {
              this.$refs.formStockRequest.setErrors({
                'headers.destination': errors.errors?.destination || [],
                'headers.category': errors.errors?.category || []
              })
            }

            this.setProductErrors(errors.errors)
            this.$refs.formDelivery.setErrors(errors.errors)
          }
        }
      )
    }
  }
}
